module.exports = __webpack_public_path__ + "static/media/banano4.625ab072.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pioricost-fruit/banano/banano4.jpeg
// module id = 40
// module chunks = 0